import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import './style.scss'

export type SidebarNav = {
  id: number
  title: string
  path?: string
  icon: string
  subNav?: SidebarNav[]
  hasPermission: boolean
  area?: string
}

type SidebarProps = {
  isOpen: boolean
  onClose: () => void
  logoText?: string
  href?: string
  items?: SidebarNav[]
  onSwitchProfile?: (area: string) => void
}

const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  onClose,
  logoText,
  href = '/',
  items,
  onSwitchProfile,
}: SidebarProps) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [expandedMenus, setExpandedMenus] = React.useState<Set<number>>(new Set())

  const goTo = (path = '', area?: string): void => {
    if (path) {
      navigate(path)
      onClose()
    }
  }

  const toggleMenu = (menuId: number): void => {
    setExpandedMenus(prev => {
      const newSet = new Set(prev)
      if (newSet.has(menuId)) {
        newSet.delete(menuId)
      } else {
        newSet.add(menuId)
      }
      return newSet
    })
  }

  return (
    <>
      {isOpen && (
        <>
          <nav className='nav-sidebar '>
            {items?.map(({ id, title, path, icon, subNav, hasPermission }, idx) => {
              const isExpanded = true // TODO: Caso seja necessário, expandir o menu, alterar para expandedMenus.has(id)
              const isFirstItem = idx === 0 
              return (
                hasPermission && (
                  <ul key={idx} className='sidebar-ul'>
                    <li
                      className={
                        location.pathname === path && !subNav
                          ? 'sidebar-li sidebar-active'
                          : 'sidebar-li'
                      }
                    >
                      {subNav && subNav.length > 0 ? (
                        isFirstItem ? (
                          // Primeiro item: comportamento original sem expansão
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 8,
                              width: '100%',
                              paddingTop: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                            }}>
                            <span style={{ fontWeight: 'bold' }}>{title}</span>
                            <img src={icon} width={30} height={30} />
                          </div>
                        ) : (
                          // Demais itens: comportamento expansível
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 8,
                              width: '100%',
                              paddingTop: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              cursor: 'pointer',
                            }}
                            onClick={() => toggleMenu(id)}
                          >
                            <span style={{ fontWeight: 'bold' }}>{title}</span>
                            <img src={icon} width={32} height={32} style={{ fontWeight: 'bold', }} />
                          </div>
                        )
                      ) : (
                        <Link
                          className={location.pathname === path ? 'sidebar-active' : ''}
                          to={`${path}`}
                          onClick={onClose}
                        >
                          <span style={{ fontWeight: 'bold' }}>{title}</span>
                        </Link>
                      )}
                    </li>
                    {
                      subNav &&
                      subNav.length > 0 &&
                      (isFirstItem || isExpanded) && // Primeiro item sempre mostra sub-itens, demais só quando expandido
                      subNav.map(({ title, path, hasPermission, area }, subIdx) => {
                        return (
                          <>
                            {hasPermission ? (
                              <ul
                                key={`${idx}-${subIdx}`}
                                className='sub-sidebar-ul'
                              >
                                <li className={'sub-sidebar-li'}>
                                  <div
                                    className='nav-item'
                                    style={{ padding: '1.5vmin', paddingLeft: '10px' }}
                                    onClick={() => goTo(path, area)}
                                  >
                                    {`${title}`}
                                  </div>
                                </li>
                              </ul>
                            ) : (
                              <></>
                            )}
                          </>
                        )
                      })
                    }
                  </ul>
                )
              )
            })}
          </nav>
          <div className='background-sidebar' onClick={onClose} />
        </>
      )
      }
    </>
  )
}

export default Sidebar
